import { Car, Driver } from '~/shared/api'
import {
  debtStatusEnumOptions,
  debtTypeEnumOptions,
} from '~/shared/config/constants'
import { Filter } from '~/shared/ui/AsyncGrid'

export const filters: Filter[] = [
  {
    field: 'startAtFrom',
    label: 'filter.start at from',
    type: 'date',
  },
  {
    field: 'startAtTo',
    label: 'filter.start at from',
    type: 'date',
  },
  {
    field: 'status',
    label: 'filter.status',
    type: 'select',
    options: debtStatusEnumOptions,
  },
  {
    field: 'sourceType',
    label: 'filter.type',
    type: 'select',
    options: debtTypeEnumOptions,
  },
  {
    field: 'driverExtId',
    label: 'filter.driver',
    type: 'autocomplete',
    fetchOptions: Driver.fetchOptionsByExtId,
  },
  {
    field: 'carId',
    label: 'filter.car',
    type: 'autocomplete',
    fetchOptions: Car.fetchOptions,
  },
  {
    field: 'isErroneous',
    label: 'filter.is erroneous',
    type: 'select',
    options: [
      { id: 'true', label: 'filter.yes' },
      { id: 'false', label: 'filter.no' },
    ],
  },
]
